import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, IconButton, Tooltip, Checkbox, FormControlLabel, CircularProgress } from '@material-ui/core';
import CropSquareIcon from '@material-ui/icons/CropSquare';
import TimelineIcon from '@material-ui/icons/Timeline';
import PlaceIcon from '@material-ui/icons/Place';
import StraightenIcon from '@material-ui/icons/Straighten';
import VisibilityIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles(() => ({
  toolbar: {
    position: 'absolute',
    top: 12,
    right: 12,
    background: 'rgba(255,255,255,0.95)',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    padding: '6px 10px',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    zIndex: 1100,
  },
  divider: {
    width: 1,
    height: 24,
    background: '#e0e0e0',
    margin: '0 4px',
  },
  btn: {
    minWidth: 0,
    padding: '6px 8px',
  },
  calibrateBtn: {
    textTransform: 'none',
    fontSize: 12,
    padding: '4px 10px',
  },
}));

const PlanEditToolbar = ({
  onDrawPolygon,
  onDrawPolyline,
  onDrawPoint,
  onCalibrate,
  calibrated,
  showMeasurements,
  onToggleMeasurements,
  matching,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.toolbar}>
      <Tooltip title="Draw polygon (area)">
        <IconButton className={classes.btn} onClick={onDrawPolygon} size="small">
          <CropSquareIcon style={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Draw line">
        <IconButton className={classes.btn} onClick={onDrawPolyline} size="small">
          <TimelineIcon style={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Place point">
        <IconButton className={classes.btn} onClick={onDrawPoint} size="small">
          <PlaceIcon style={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>

      <div className={classes.divider} />

      <Tooltip title={calibrated ? 'Recalibrate scale' : 'Set scale (required for measurements)'}>
        <Button
          className={classes.calibrateBtn}
          variant={calibrated ? 'text' : 'outlined'}
          color={calibrated ? 'default' : 'primary'}
          startIcon={<StraightenIcon style={{ fontSize: 16 }} />}
          onClick={onCalibrate}
          size="small"
        >
          {calibrated ? 'Recalibrate' : 'Set Scale'}
        </Button>
      </Tooltip>

      {calibrated && (
        <>
          <div className={classes.divider} />
          <Tooltip title="Show/hide segment lengths">
            <FormControlLabel
              control={
                <Checkbox
                  checked={showMeasurements}
                  onChange={onToggleMeasurements}
                  size="small"
                  color="primary"
                  style={{ padding: 4 }}
                />
              }
              label={<span style={{ fontSize: 12 }}>Lengths</span>}
              style={{ marginLeft: 0, marginRight: 0 }}
            />
          </Tooltip>
        </>
      )}

      {matching && (
        <>
          <div className={classes.divider} />
          <CircularProgress size={18} style={{ color: '#7c3aed' }} />
          <span style={{ fontSize: 11, color: '#7c3aed', marginLeft: 4 }}>Matching...</span>
        </>
      )}
    </div>
  );
};

export default PlanEditToolbar;
